import {
  AfterViewInit,
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import { EventCategoryListResponseDto } from '@whetstoneeducation/hero-common';

enum EventCategoryListColumnEnum {
  NAME = 'Name',
  ACTIONS = 'ACTIONS'
}

@Component({
  selector: 'app-event-category-list-table',
  templateUrl: './event-category-list-table.component.html',
  styleUrls: ['./event-category-list-table.component.scss']
})
export class EventCategoryListTableComponent
  extends BaseTableComponent<EventCategoryListResponseDto>
  implements AfterViewInit
{
  @Output() onEdit = new EventEmitter<number>();
  @Output() onDelete = new EventEmitter<number>();
  @ViewChild('actionButtons') actionButtons!: TemplateRef<any>;
  public templates: { [key: string]: TemplateRef<any> } = {};
  ngAfterViewInit(): void {
    if (this.actionButtons) {
      this.templates['actionButtons'] = this.actionButtons;
    }
  }
  public get displayedColumns() {
    return Object.values(EventCategoryListColumnEnum);
  }
  public columns = EventCategoryListColumnEnum;
  constructor() {
    super();
  }

  delete(id: number) {
    this.onDelete.emit(id);
  }

  edit(id: number) {
    this.onEdit.emit(id);
  }

  public getColumnValue(column: string, row: any): any {
    switch (column) {
      case EventCategoryListColumnEnum.NAME:
        return row.name;
      case EventCategoryListColumnEnum.ACTIONS:
        return {
          context: {
            eventCategory: row
          },
          template: this.templates.actionButtons
        };
    }
  }
}
